<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true">

      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" @click="addProjectPopup">{{ $t('add') }}</vs-button>
      </template>
      <vs-divider></vs-divider>

    </vx-card>

    <vx-card id="projectsDataContainer" :title="$tc('project', 2)" class="mb-8 vs-con-loading__container">

      <shared-project-list
        :projects="projects"
        @customClickEdit="editProjectPopup"
        @customClickDelete="deleteProject"
      ></shared-project-list>

      <template slot="footer">
        <paginate
          :total="projectPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadProjects"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal :title="$t('Add Project')" id="addProject" :active.sync="modals.add" size="xl">
      <shared-project-add
        @addProjectSuccess="addProjectSuccess"
        :progressStatusOptions="progressStatusOptions"
        :userOptions="userOptions"
      ></shared-project-add>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="addProjectButton" color="primary" type="filled" @click.prevent="addProject">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('Edit Project')" id="editProject" :active.sync="modals.edit" size="xl">
      <div id="EditProjectFormContainer" class="vs-con-loading__container">
        <shared-project-edit
          @editProjectSuccess="editProjectSuccess"
          :progressStatusOptions="progressStatusOptions"
          :userOptions="userOptions"
        ></shared-project-edit>
        <vs-divider></vs-divider>
        <div class="flex justify-end">
          <vs-button id="editProjectButton" color="primary" type="filled" @click.prevent="editProject">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import Project from '@/models/Project'
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedProjectList from '@/views/Shared/Projects/List'
import SharedProjectAdd from '@/views/Shared/Projects/Add'
import SharedProjectEdit from '@/views/Shared/Projects/Edit'

export default {
  name: 'User.Projects',
  mixins: [Paginate],
  components: {
    SharedProjectList,
    SharedProjectAdd,
    SharedProjectEdit,
    Modal
  },
  data () {
    return {
      itemPerPage: null,
      projects: {},
      projectPages: 0,
      projectSearchParams: [],
      progressStatusOptions: [],
      userOptions: [],
      modals: {
        add: false,
        edit: false
      }
    }
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        EventBus.$emit('initProjectFormData')
      }
    },
    'modals.edit' (val) {
      if (!val) {
        EventBus.$emit('initProjectFormData')
      }
    }
  },
  mounted () {
    this.loadProjects(this.initialPage, null)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_project_table', this.reloadProjects)
  },
  methods: {
    reloadProjects () {
      this.loadProjects(this.initialPage, null)
    },
    async loadProjects (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#projectsDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      const response = await Project.all({ ...this.projectSearchParams, page, itemPerPage })
      this.projects = response.data.data.projects
      this.projectPages = response.data.meta.pagination.last_page
      this.progressStatusOptions = response.data.meta.options.progressStatuses
      this.userOptions = response.data.meta.options.users
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#projectsDataContainer > .con-vs-loading')
    },
    addProject () {
      EventBus.$emit('initAddProject')
    },
    addProjectModal () {
      this.modals.add = true
    },
    addProjectPopup () {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'add-project', {}, this.addProjectModal)
    },
    addProjectSuccess () {
      this.loadProjects(this.initialPage)
      this.modals.add = false
    },
    editProject () {
      EventBus.$emit('initUpdateProject')
    },
    editProjectModal (data) {
      this.modals.edit = true
      EventBus.$emit('initEditProject', {id: data.id})
    },
    editProjectPopup (id) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-project', {id}, this.editProjectModal)
    },
    editProjectSuccess () {
      this.loadProjects(this.initialPage)
      this.modals.edit = false
    },
    async deleteProject (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Project.destroy({ id })
        this.loadProjects()
      }
    }
  }
}
</script>

<style lang="scss">

</style>
